import React, { Component } from 'react';
import { styled } from '@material-ui/core/styles';
import { Box, TextField, MenuItem, RadioGroup, FormControlLabel, Radio, Button, FormControl, FormHelperText } from '@material-ui/core';
import { clone, newId, timeFormat2 } from '../../../../../common/utils';
import { ADD, CLIENT, EDIT, ERR, globalData, NORMAL, TEXT, VIEW } from '../../../../../common/common';

const Root = styled(Box)({
    width: '100%',
})

class PanelNormal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: {
                ".CHO.N.": "",
                ".CHO.Em": "",
                ".CHO.AddrNPho": {
                    "phone": "",
                    "unit": "",
                    "street": "",
                    "city": "",
                    "country": "",
                    "state": "",
                    "zipcode": "",
                },
                "rc": "",
                "relation": "",
            },
            stateData: ["CN", "US"],
            rcData: ["Client's"],
            panelState: ADD,
            showMsg: false
        }
        this.handleAdd = this.handleAdd.bind(this);
        this.handleEdit = this.handleEdit.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }
    render() {
        const {
            data,
            panelState,
            stateData,
            rcData
        } = this.state;
        const content = () => {
            if (panelState === VIEW) {
                return clientView()
            } else if (panelState === EDIT || panelState === ADD) {
                return clientEdit()
            }
        }
        const unitView = (isInput = true) => {
            if (data[".CHO.AddrNPho"]["country"] === "CN") {
                if (isInput) {
                    return <div className="text-wapper">
                        <div className="text-title">Unit</div>
                        <TextField
                            className="text-field"
                            value={data[".CHO.AddrNPho"]["unit"]}
                            onChange={e => this.handleChange(e, 'unit')}
                            margin="dense"
                            variant="outlined"
                            error={this.validator(ERR,)}
                            helperText={this.validator(TEXT,)}
                        />
                    </div>
                } else {
                    return <div className="text-wapper">
                        <div className="text-title">Unit</div>
                        <div>{data[".CHO.AddrNPho"]["unit"]}</div>
                    </div>
                }
            }
        }
        const emailView = (isInput = true) => {
            if (isInput) {
                return <div className="text-wapper">
                    <div className="text-title">Email (Optional)</div>
                    <TextField
                        className="text-field"
                        value={data[".CHO.Em"]}
                        onChange={e => this.handleChange(e, '.CHO.Em')}
                        margin="dense"
                        variant="outlined"
                    />
                </div>
            }
        }
        const clientView = () => {
            return <div className="panel-wapper v v-r">
                <div className="flow">
                    <div className="text-wapper">
                        <div className="text-title">Name</div>
                        <div>{data[".CHO.N."]}</div>
                    </div>
                    <div className="text-wapper">
                        <div className="text-title">First Relation to the {data["rc"]}</div>
                        <div>{data["rc"]} {data["relation"]}</div>
                    </div>
                    <div className="text-wapper">
                        <div className="text-title">Phone Number</div>
                        <div>{data[".CHO.AddrNPho"]["phone"]}</div>
                    </div>
                    <div className="text-wapper">
                        <div className="text-title">Choose The Country</div>
                        <div>{data[".CHO.AddrNPho"]["country"]}</div>
                    </div>
                    <div className="text-wapper">
                        <div className="text-title">Street</div>
                        <div>{data[".CHO.AddrNPho"]["P.DOB"]}</div>
                    </div>
                    <div className="text-wapper">
                        <div className="text-title">City</div>
                        <div>{data[".CHO.AddrNPho"]["city"]}</div>
                    </div>
                    <div className="text-wapper">
                        <div className="text-title">State</div>
                        <div>{data[".CHO.AddrNPho"]["state"]}</div>
                    </div>
                    <div className="text-wapper">
                        <div className="text-title">Zip Code</div>
                        <div>{data[".CHO.AddrNPho"]["zipcode"]}</div>
                    </div>
                </div>
                <div>
                    <Button size="small" color="primary" onClick={this.handleEdit}>Edit</Button>
                </div>
            </div>
        }
        const clientEdit = () => {
            return <div className="panel-wapper v v-r">
                <div className="flow">
                    <div className="text-wapper">
                        <div className="text-title">Name</div>
                        <TextField
                            className="text-field"
                            value={data[".CHO.N."]}
                            onChange={e => this.handleChange(e, '.CHO.N.')}
                            margin="dense"
                            variant="outlined"
                            error={this.validator(ERR, ".CHO.N.")}
                            helperText={this.validator(TEXT, ".CHO.N.")}
                        />
                    </div>
                    <div className="text-wapper-2">
                        <div className="text-title">First Relation to the {data["rc"]}</div>
                        <div className="h">
                            <TextField
                                select
                                className="text-field-1"
                                value={data["rc"]}
                                onChange={e => this.handleChange(e, 'rc')}
                                margin="dense"
                                variant="outlined"
                                error={this.validator(ERR, "rc")}
                                helperText={this.validator(TEXT, "rc")}
                            >
                                {rcData.map((data, index) => (
                                    <MenuItem key={index} value={data}>
                                        {data}
                                    </MenuItem>
                                ))}
                            </TextField>
                            <TextField
                                className="text-field-2"
                                value={data["relation"]}
                                onChange={e => this.handleChange(e, 'relation')}
                                margin="dense"
                                variant="outlined"
                                error={this.validator(ERR, "relation")}
                                helperText={this.validator(TEXT, "relation")}
                            />
                        </div>
                    </div>
                    <div className="text-wapper">
                        <div className="text-title">Phone Number</div>
                        <TextField
                            className="text-field"
                            value={data[".CHO.AddrNPho"]["phone"]}
                            onChange={e => this.handleChange(e, 'phone')}
                            margin="dense"
                            variant="outlined"
                            error={this.validator(ERR, ".CHO.AddrNPho", "phone")}
                            helperText={this.validator(TEXT, ".CHO.AddrNPho", "phone")}
                        />
                    </div>
                    <div className="text-wapper">
                        <div className="text-title">Choose The Country</div>
                        <TextField
                            select
                            className="text-field"
                            value={data[".CHO.AddrNPho"]["country"]}
                            onChange={e => this.handleChange(e, 'country')}
                            margin="dense"
                            variant="outlined"
                            error={this.validator(ERR, ".CHO.AddrNPho", "country")}
                            helperText={this.validator(TEXT, ".CHO.AddrNPho", "country")}
                        >
                            {stateData.map((data, index) => (
                                <MenuItem key={index} value={data}>
                                    {data}
                                </MenuItem>
                            ))}
                        </TextField>
                    </div>
                    {unitView()}
                    <div className="text-wapper">
                        <div className="text-title">Street</div>
                        <TextField
                            className="text-field"
                            value={data[".CHO.AddrNPho"]["street"]}
                            onChange={e => this.handleChange(e, 'street')}
                            margin="dense"
                            variant="outlined"
                            error={this.validator(ERR, ".CHO.AddrNPho", "street")}
                            helperText={this.validator(TEXT, ".CHO.AddrNPho", "street")}
                        />
                    </div>
                    <div className="text-wapper">
                        <div className="text-title">City</div>
                        <TextField
                            className="text-field"
                            value={data[".CHO.AddrNPho"]["city"]}
                            onChange={e => this.handleChange(e, 'city')}
                            margin="dense"
                            variant="outlined"
                            error={this.validator(ERR, ".CHO.AddrNPho", "city")}
                            helperText={this.validator(TEXT, ".CHO.AddrNPho", "city")}
                        />
                    </div>
                    <div className="text-wapper">
                        <div className="text-title">State</div>
                        <TextField
                            className="text-field"
                            value={data[".CHO.AddrNPho"]["state"]}
                            onChange={e => this.handleChange(e, 'state')}
                            margin="dense"
                            variant="outlined"
                            error={this.validator(ERR, ".CHO.AddrNPho", "state")}
                            helperText={this.validator(TEXT, ".CHO.AddrNPho", "state")}
                        />
                    </div>
                    <div className="text-wapper">
                        <div className="text-title">Zip Code</div>
                        <TextField
                            className="text-field"
                            value={data[".CHO.AddrNPho"]["zipcode"]}
                            onChange={e => this.handleChange(e, 'zipcode')}
                            margin="dense"
                            variant="outlined"
                            error={this.validator(ERR, ".CHO.AddrNPho", "zipcode")}
                            helperText={this.validator(TEXT, ".CHO.AddrNPho", "zipcode")}
                        />
                    </div>
                    {emailView()}
                </div>

            </div>
        }
        return (
            <Root>
                {content()}
            </Root>
        )
    }
    componentDidMount() {
        this.initData();
    }
    componentDidUpdate(prevProps) {
        if (this.props.data !== prevProps.data) {
            const data = this.props.data;
            if (data && this.props.isAdd) {
                let panelState = ADD;
                this.setState(() => ({
                    data,
                    panelState
                }))
            }
        }
    }
    initData() {
        const { id, state, isAdd } = this.props;
        let data = {};
        let panelState = "";
        if (isAdd) {
            panelState = ADD;
            data = {
                ".CHO.N.": "",
                ".CHO.AddrNPho": {
                    "phone": "",
                    "unit": "",
                    "street": "",
                    "city": "",
                    "country": "",
                    "state": "",
                    "zipcode": "",
                },
                ".CHO.Em": "",
                "rc": "",
                "relation": "",
                "id": newId(),
                "type": NORMAL
            }
        } else {
            panelState = EDIT;
            const singelData = this.extractData(id);
            data = singelData ? singelData : {};
        }
        console.log("dataaaa",isAdd,data)
        this.setState(() => ({
            data,
            panelState
        }))
    }
    extractData(id) {
        let data = {};
        const singleArr = clone(globalData.singleArr);
        for (const obj of singleArr) {
            if (obj.id === id) {
                data = obj;
            }
        }
        return data;
    }
    setSingleArr() {
        const { data } = this.state;
        const singleArr = globalData.singleArr;
        for (const obj of singleArr) {
            if (obj.id === data.id) {
                Object.assign(obj, data);
            }
        }
    }
    handleAdd() {
        this.setState({
            panelState: EDIT
        })
    }
    handleEdit() {
        this.setState({
            panelState: EDIT
        })
    }
    handleSave(callback = null) {
        const { data } = this.state;
        const { isAdd } = this.props;
        this.setState({
            showMsg: true
        }, () => {
            if (this.doNext()) {
                this.setSingleArr();
                if (callback) callback(true);
                this.props.updateInfoData(data, isAdd);
            } else {
                if (callback) callback(false);
            }
        })
    }
    handleCancel() {
        this.setState({
            panelState: VIEW
        })
    }
    handleChange(e, name) {
        const value = e.target.value;
        const { data } = this.state;
        data[name] = value;
        if (name === "phone" || name === "unit"
            || name === "street" || name === "city"
            || name === "country" || name === "state"
            || name === "zipcode") {
            data[".CHO.AddrNPho"][name] = value;
        } else if (name === "rc" || name === "relation") {
            data[".CHO.R.C."] = data["rc"] + ";" + data["relation"];
        }
        this.setState(() => ({
            data
        }))
    }
    splitName(str) {
        let strArr = str.split(" ");
        if (strArr.length >= 2) {
            return strArr[strArr.length - 1];
        } else {
            return "";
        }
    }
    doNext() {
        const { data } = this.state;
        let canNext = true;
        for (const key in data) {
            if (data.hasOwnProperty(key)) {
                if (key === ".CHO.AddrNPho") {
                    canNext = this.verifyAddrValue(data[key]);
                    if (canNext) {
                        continue;
                    }
                } else if (key === ".CHO.Em" || key === "P.W.Pho" || key === "S.W.Pho") {
                    continue;
                }
                if (data[key] === "" || canNext === false) {
                    if (key === "phone") continue;
                    return false;
                }
            }
        }
        return true;
    }
    verifyAddrValue(obj) {
        for (const key in obj) {
            if (obj.hasOwnProperty(key)) {
                if (key === "unit" && obj[key] === "") {
                    if (obj["country"] === "US") {
                        continue;
                    }
                }
                if (key === "phone") {
                    continue;
                }
                if (obj[key] === "") {
                    return false;
                }
            }
        }
        return true;
    }
    validator(type, name1, name2) {
        const { data, showMsg } = this.state;
        if (showMsg) {
            const value = name2 ? data[name1][name2] : data[name1];
            if (type === ERR) {
                return value ? false : true;
            } else {
                return value ? "" : "This field is required."
            }
        } else {
            const value = type === ERR ? false : "";
            return value;
        }
    }
    isDisabled() {
        return false
        // const { state } = this.props;
        // if (state === ADD) {
        //     return false;
        // } else if (state === VIEW) {
        //     return true;
        // } else if (state === EDIT) {
        //     return false;
        // }
    }
}

export default PanelNormal;